import { render, staticRenderFns } from "./RelLiderRede.vue?vue&type=template&id=4a2e1d8b"
import script from "./RelLiderRede.vue?vue&type=script&lang=js"
export * from "./RelLiderRede.vue?vue&type=script&lang=js"
import style0 from "./RelLiderRede.vue?vue&type=style&index=0&id=4a2e1d8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports